import { render, staticRenderFns } from "./allocationAuditDiv.vue?vue&type=template&id=d387d9e0"
import script from "./allocationAuditDiv.vue?vue&type=script&lang=js"
export * from "./allocationAuditDiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports